import PrintModalPagination from "./PrintModalPagination";

export default PrintModalPagination;
